import * as TYPES from './Redux.actionTypes';

const initialState = {
  isNavDrawerOpen: false,
  displayedWeek: '',
  displayedMonth: '',
  devotionalGroupLeader: '',
  selectedDevotionalGroup: '', //'21e7a935-5e6b-435c-9021-22156f71449d',
  isInitialLoading: true,
  loggedInDevoteeId: '',
  isAuthorized: false,
  isAuthenticated: false,
};

export const views = (state = initialState, { type, value }) => {
  switch (type) {
    case TYPES.SET_NAV_DRAWER_IS_OPEN:
      return { ...state, isNavDrawerOpen: value };
    case TYPES.SET_DISPLAYED_WEEK:
      return { ...state, displayedWeek: value };
    case TYPES.SET_DISPLAYED_MONTH:
      return { ...state, displayedMonth: value };
    case TYPES.SET_DEVOTIONAL_GROUP_LEADER:
      return { ...state, devotionalGroupLeader: value };
    case TYPES.SELECTED_DEVOTIONAL_GROUP:
      return { ...state, selectedDevotionalGroup: value };
    case TYPES.SET_IS_INITIAL_LOADING:
      return { ...state, isInitialLoading: value };
    case TYPES.SET_LOGGED_IN_DEVOTEE_ID:
      return { ...state, loggedInDevoteeId: value };
    case TYPES.SET_IS_AUTHORIZED:
      return { ...state, isAuthorized: value };
    case TYPES.SET_IS_AUTHENTICATED:
      return { ...state, isAuthenticated: value };
    default:
      return state;
  }
};
